'use strict';

var JSConstants = require('_core_ext/pages/storelocator/constants'),
    addToCart = require('_core_ext/pages/product/addToCart'),
    handlebarsHelper = require('_core_ext/handlebarsHelper'),
    _ = require('lodash');

var selectors = {
        map: JSConstants.CLASS_GOOLEMAPS_MAP,
        storeInfo: ".js-store-info",
        distance: ".js-distance",
        nearestStoresBlock: ".js-nearest-stores"
};

var STORE_DETAILS_MAP_ZOOM = 14;
var KILOMETERS_CONVERSATION_LEVEL = Constants.KILOMETERS_CONVERSATION_LEVEL;

var $cache = generateCache(selectors);

function generateCache(selectors) {
    return _.reduce(selectors, function(memo, selector, key) {
        memo[key] = $(selector);
        return memo;
    }, {});
}

function parseStoreInfo() {
    var storeJSON = $cache.storeInfo.val();
    try {
        return JSON.parse(storeJSON);
    } catch (e) {
        throw ("Error Store Info JSON", e);
    }
}

/* eslint-disable no-unused-vars */
function initMap() {
    var userIcon = {
            url: Urls.mapUserIcon
    }, storeIconTrade = {
            url: Urls.mapStoreIcon,
            scaledSize: new google.maps.Size(parseFloat(SitePreferences.STORE_PIN_WIDTH), parseFloat(SitePreferences.STORE_PIN_HEIGHT))
    }, storeIconRetail = {
            url: Urls.mapStoreRetailIcon,
            scaledSize: new google.maps.Size(parseFloat(SitePreferences.STORE_PIN_WIDTH), parseFloat(SitePreferences.STORE_PIN_HEIGHT))
    }, map = new google.maps.Map($cache.map[0], {
        zoom: Math.max(SitePreferences.DEFAULT_MAP_ZOOM, STORE_DETAILS_MAP_ZOOM),
            disableDefaultUI: true,
            zoomControl: true,
            streetViewControl: true
    }), storeInfo = parseStoreInfo(),
    marker = new google.maps.Marker({
        position: {
            lat: storeInfo.latitude,
            lng: storeInfo.longitude
        },
        map: map,
        title: storeInfo.name,
        icon: storeInfo.isTradeOnly ? storeIconTrade : storeIconRetail
    });
    map.setCenter({lat: storeInfo.latitude, lng: storeInfo.longitude});

    renderNearestStores(storeInfo.latitude, storeInfo.longitude, storeInfo.ID);
}

function init() {
    handlebarsHelper.compileTemplates();
    var data = {
            key: SitePreferences.GOOGLE_API_KEY,
            libraries: 'geometry,places',
            region: SitePreferences.GOOGLE_MAPS_REGION,
            language: SitePreferences.LOCALE
        }, isIE11 = document.body.style.msTextCombineHorizontal === '';

    if (isIE11) {
        var script = document.createElement('script');
        var url = Urls.googlemapsAPIUrl + '?key=' +
                  SitePreferences.GOOGLE_API_KEY + '&libraries=geometry,places&region=' +
                  SitePreferences.GOOGLE_MAPS_REGION + '&language=' + SitePreferences.LOCALE;

        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
        script.onload = initMap;
    } else {
        $.ajax({
            url: Urls.googlemapsAPIUrl,
            data: data,
            dataType: 'jsonp',
            success: initMap
        });
    }

    addToCart();
    expandOverflowingCards();
    wrapEmailLinks();
}

function renderNearestStores(lat, lng, currentStoreId) {
    var data = {lat: lat, lng: lng, nearestStoresRadius: SitePreferences.NEAREST_STORES_RADIUS * 1000, currentStoreId: currentStoreId};
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
            data.lat = position.coords.latitude;
            data.lng = position.coords.longitude;
            data.currentStoreId = '';
            var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            processLocation(data, position);
        }, function() {
            processLocation(data, null);
        });
    } else {
        processLocation(data, null);
    }
}

function processLocation(data, position) {
    $.ajax({
        url: Urls.getNearestStores,
        data: data,
        dataType: 'json',
        success: function (response) {
            if (response.success && response.stores) {
                var filteredStores = response.stores.filter(function(store) {
                    return !store.closed;
                });
                filteredStores.length = Math.min(filteredStores.length, 4);
                var storesWithOrder = filteredStores.map(function(store, index) {
                    var storeWithOrder = Object.assign({}, store);
                    storeWithOrder.orderNumber = index + 1;
                    var distance = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng({lat: data.lat, lng: data.lng}), new google.maps.LatLng({lat: store.latitude, lng: store.longitude})) * KILOMETERS_CONVERSATION_LEVEL;

                    storeWithOrder.distance = parseFloat(distance / 1000).toFixed(3);
                    store.distanceText = parseFloat(distance / 1000).toFixed(1);
                    storeWithOrder.distanceFormatted = Resources.GOOGLEMAPS_DISTANCE_MSGF.replace('{0}', store.distanceText);
                    return storeWithOrder;
                });
                $cache.nearestStoresBlock.html(Handlebars.templates.nearestStoresTemplate({data: storesWithOrder}));
            }
        }
    });
}

function wrapEmailLinks() {
    $(JSConstants.CLASS_STORE_EMAIL).each(function () {
        var $link = $(this);
        var email = $link.text();
        var atIndex = email.indexOf('@');
        if (atIndex < 0) {
            return;
        }
        var local = email.substring(0, atIndex);
        var domain = email.substring(atIndex);
        $link.html(document.createTextNode(local)).append($('<wbr>')).append(document.createTextNode(domain));
    });
}

function expandOverflowingCards() {
    var gridHasOverflow = false;

    $(JSConstants.CLASS_STORE_CARD_OVERFLOW_CHECK).each(function () {
        if (this.scrollHeight > this.clientHeight) {
            gridHasOverflow = true;
        }
    });

    if (gridHasOverflow) {
        $(JSConstants.CLASS_STORE_DETAILS_GRID).addClass(JSConstants.CLASS_GRID_HAS_OVERFLOW);
    }

    $(JSConstants.CLASS_EXPANDABLE_CARD).each(function () {
        if (this.scrollHeight > this.clientHeight) {
            $(this).addClass(JSConstants.CLASS_CARD_WIDE);
        }
        $(this).addClass(JSConstants.CLASS_CARD_READY);
    });

    $(JSConstants.CLASS_STORE_DETAILS_GRID).addClass(JSConstants.CLASS_GRID_READY);
}

module.exports.init = init;
